export function afterIncome(budget: Budget, record: RecordEntry): Budget {
  const added = budget.added + record.amount;
  return {...budget, added};
}
